import React, { Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import AuthenSelectors from "store/selectors/AuthenSelectors";
import {
  DialogError,
  DialogSubmit,
  DialogSuccess,
  DialogWarning,
  DialogWarningAutoWidth,
  DialogSubmit_WARNNING,
} from "./DialogFormItem";

export default function Template(props) {
  const SuccessOpen = useSelector(AuthenSelectors.selectSuccessOpen);
  const SuccessMsg = useSelector(AuthenSelectors.selectSuccessMsg);
  const WarningOpen = useSelector(AuthenSelectors.selectWarningOpen);
  const WarningMsg = useSelector(AuthenSelectors.selectWarningMsg);
  const WarningAutoOpen = useSelector(AuthenSelectors.selectWarningAutoOpen);
  const WarningAutoMsg = useSelector(AuthenSelectors.selectWarningAutoMsg);
  const ErrorOpen = useSelector(AuthenSelectors.selectErrorOpen);
  const ErrorMsg = useSelector(AuthenSelectors.selectErrorMsg);
  const SubmitOpen = useSelector(AuthenSelectors.selectSubmitOpen);
  const SubmitMsg = useSelector(AuthenSelectors.selectSubmitMsg);
  const SubmitFn = useSelector(AuthenSelectors.selectSubmitFn);
  const SubmitCancelFn = useSelector(AuthenSelectors.selectSubmitCancelFn);
  const SubmitIsload = useSelector(AuthenSelectors.selectSubmitIsload);
  const Submit_WARNNING_Open = useSelector(
    AuthenSelectors.selectSubmit_WARNNING_Open
  );
  const Submit_WARNNING_Msg = useSelector(
    AuthenSelectors.selectSubmit_WARNNING_Msg
  );
  const Submit_WARNNING_Fn = useSelector(
    AuthenSelectors.selectSubmit_WARNNING_Fn
  );
  const Submit_WARNNING_Isload = useSelector(
    AuthenSelectors.selectSubmit_WARNNING_Isload
  );
  const Submit_SUCCESS_Fn = useSelector(
    AuthenSelectors.selectSubmit_SUCCESS_Fn
  );
  useEffect(() => { }, [SubmitIsload]);
  return (
    <Fragment>
      <DialogSuccess
        handleClick={Submit_SUCCESS_Fn}
        open={SuccessOpen}
        sMsg={SuccessMsg}
      />
      <DialogWarning
        handleClick={(c) => { }}
        open={WarningOpen}
        sMsg={WarningMsg}
        handleClickSubmit={Submit_SUCCESS_Fn}
      />
      <DialogWarningAutoWidth
        handleClick={(c) => { }}
        open={WarningAutoOpen}
        sMsg={WarningAutoMsg}
        handleClickSubmit={Submit_SUCCESS_Fn}
      />
      <DialogError handleClick={(c) => { }} open={ErrorOpen} sMsg={ErrorMsg} />
      <DialogSubmit
        handleClick={(c) => { }}
        open={SubmitOpen}
        sMsg={SubmitMsg}
        handleClickSubmit={SubmitFn}
        IsLoad={SubmitIsload}
        handleCancel={SubmitCancelFn}
      />
      <DialogSubmit_WARNNING
        handleClick={(c) => { }}
        open={Submit_WARNNING_Open}
        sMsg={Submit_WARNNING_Msg}
        handleClickSubmit={Submit_WARNNING_Fn}
        IsLoad={Submit_WARNNING_Isload}
      />
    </Fragment>
  );
}